import FormProperties from './FormProperties'
import { Grid, Box, Card } from '@material-ui/core'
import React, { useRef, useState } from 'react'
import { components } from 'cng-web-lib'
import pathMap from 'src/paths/pathMap'
import { useLocation } from 'react-router-dom'
import ConfirmDialog from 'src/views/common/ConfirmDialog'
import MPCIApiUrls from '../Common/services/MPCIApiService'
import makeValidationSchema from './MakeValidationSchema'

const {
  button: { CngButton },
  form: { CngAddForm }
} = components

function AddPage({ history, showNotification }) {
  const loc = useLocation()
      const onSuccessCallback = useRef(() => {
    // Redirect to list view after success
    history.push(pathMap.UAE_MPCI_PARTY_MASTER_LIST_VIEW)
  })

  let formikPropsData
  if (loc.state !== undefined) {
    formikPropsData = {
      ...FormProperties.formikProps,
      initialValues: loc.state,
      validationSchema: makeValidationSchema()
    }
  } else {
    formikPropsData = {
      ...FormProperties.formikProps,
      validationSchema: makeValidationSchema()
    }
  }

  return (
    <Card>
      <Box padding={2}>
        <CngAddForm
          fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
          history={history}
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap, shouldDisableMap) => (
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          formikProps={formikPropsData}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
                                        create={{
            url: MPCIApiUrls.PARTY_MASTER.POST,
            onSuccess: () => {
              showNotification('success', 'Party created successfully.')
              setTimeout(() => onSuccessCallback.current(), 500)
            }
          }}
          renderButtonSection={(loading) => (
            <ButtonSection history={history} loading={loading} />
          )}
        />
      </Box>
    </Card>
  )
}

export default AddPage

function ButtonSection({ history, loading }) {
  const [confirmDialog, setConfirmDialog] = useState(false)

  return (
    <>
      <Grid container justify='space-between' spacing={3}>
        <Grid item xs='auto'>
          <CngButton
            color='secondary'
            disabled={loading}
            onClick={() => setConfirmDialog(true)}
            size='medium'
          >
            Discard
          </CngButton>
        </Grid>
        <Grid item xs='auto'>
          <CngButton
            color='primary'
            disabled={loading}
            type='submit'
            size='medium'
            shouldShowProgress={loading}
          >
            Save
          </CngButton>
        </Grid>
      </Grid>
      <ConfirmDialog
        isConfirmDialogOpen={confirmDialog}
        closeDialog={() => setConfirmDialog(false)}
        confirmDialog={() => history.push(pathMap.UAE_MPCI_PARTY_MASTER_LIST_VIEW)}
        content="All progress in this session will be lost and can't be restored. Are you sure about this?"
        okMsg='Yes, discard'
        cancelMsg='Continue editing'
        title='Discard'
      />
    </>
  )
}
